import { Currency } from '../../../Generated/Commodity-Management-Api';
import { CurrencyHelper } from '../../../Helpers';

interface StoneXNumberProps {
  number?: number;
  decimals?: number;
  allowMoreDecimals?: boolean;
  ifNoNumber?: string;
  colored?: boolean;
  flipped?: boolean;
  percent?: boolean;
  currency?: Currency;
  standardNotation?: boolean;
  className?: string;
}

export function StoneXNumberFormat(props: StoneXNumberProps): string {
  const defaultProps = {
    ...props,
    decimals: props.decimals ?? 0,
    allowMoreDecimals: props.allowMoreDecimals ?? false,
    colored: props.colored ?? false,
    flipped: props.flipped ?? false,
    percent: props.percent ?? false,
    standardNotation: props.standardNotation ?? false
  };

  return defaultProps.standardNotation
    ? getNumberWithStandardNotation(defaultProps)
    : getNumberWithAccountingNotation(defaultProps);
}

export function StoneXNumber(props: StoneXNumberProps) {
  const { number, colored = false, flipped = false, className = '' } = props;
  
  const displayNumber = StoneXNumberFormat(props);
  const colorClass = `${getColorClass(number, colored, flipped) || ''} ${className}`.trim();

  return (
    <span className={colorClass} style={{width: '100%', textAlign: 'right'}}>
      {displayNumber}
    </span>
  );
}

function getFormattedNumber(props: StoneXNumberProps): string {
  const { number, decimals = 0, allowMoreDecimals = false, percent = false, currency, ifNoNumber: ifEmpty = '-' } = props;

  if (number === undefined || number == null) {
    return ifEmpty;
  }

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimals,
    maximumFractionDigits: allowMoreDecimals ? 10 : decimals,
  };

  if (percent) {
    options.style = 'percent';
  } else if (CurrencyHelper.isFormattable(currency)) {
    options.style = 'currency';
    options.currency = currency;
    options.currencyDisplay = 'symbol';
  }

  return Math.abs(number).toLocaleString(undefined, options);
}

function getNumberWithStandardNotation(props: StoneXNumberProps): string {
  const { number } = props;
  const isNegative = number !== undefined && number < 0;
  const formattedNumber = getFormattedNumber(props);
  return isNegative ? `-${formattedNumber}` : formattedNumber;
}

function getNumberWithAccountingNotation(props: StoneXNumberProps): string {
  const { number } = props;
  const isNegative = number !== undefined && number < 0;
  const formattedNumber = getFormattedNumber(props);
  return isNegative ? `(${formattedNumber})` : formattedNumber;
}

function getColorClass(number: number | undefined, colored: boolean, flipped: boolean) {
  if (!colored || number === undefined || number === 0) return undefined;
  if (flipped) {
    return number < 0 ? 'green' : 'red';
  }
  else {
    return number > 0 ? 'green' : 'red';
  }
}
